var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d61853afb75fa9aed3dc148046e9fc28cb7836da"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["customer-frontend@linkgraph"]={id:"d61853afb75fa9aed3dc148046e9fc28cb7836da"};
      